var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resources-base-table',{attrs:{"headers":_vm.headers,"items":_vm.carrerasSede},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'carreraSede', params: { id: item.id } }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("carrera sede")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }